import React from 'react';
import Nav from '../../components/common/Nav'
import Footer from '../../components/common/Footer'
import ContactBody from '../../components/contactuscomponents/ContactBody';
export default function ContactPage() {
  return (
    <div>
      <Nav />
     <ContactBody />
     <Footer />
    </div>
  )
}
